module.exports = __webpack_public_path__ + "img/3.c61efe2b.jpg";